import { Avatar } from 'antd';
import AddSquareModal from './components/AddSquareModal';
import './index.less';
export default (list: any) => {
  return [
    {
      name: <AddSquareModal />,
      path: '/create',
      access: '/assistantInfo',
      routes: list.map((item) => {
        return {
          path:
            item?.assistantState === 1
              ? `/assistantInfo/${item.id}/hotCreative`
              : '/null',
          name: <span className="menu-ellipsis">{item.assistantName}</span>,
          icon: <Avatar src={item.assistantImage} />,
          component: './AssistantInfo',
        };
      }),
    },
  ];
};
